<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<div class="table-container px-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="order_confirmations"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<OrderConfirmationRecord :item="item" @redirect="redirectToShowPage($event)" />
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import Qs from "qs"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import PaginationModule from "../../modules/PaginationModule.vue"
import OrderConfirmationRecord from "./components/OrderConfirmationRecord.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		OrderConfirmationRecord,
	},
	data() {
		return {
			mainTitle: "受注内容確認書",
			pageTitle: "受注内容確認書一覧",
			headers: [
				{ text: "受注日付", value: "matter.order_date", width: "100px" },
				{ text: "作成者", value: "created_user", width: "150px" },
				{ text: "作成日", value: "created_at", width: "80px" },
				{ text: "受注No", value: "matter.id", width: "80px" },
				{ text: "手配元(ライニング製品の母材)", value: "source_of_base_material", width: "100px" },
				{ text: "手配可否", value: "arrangement_availability", width: "120px" },
				{ text: "納期日", value: "ordered_product.matter.deadline", width: "100px" },
				{
					text: "得意先",
					value: "ordered_product.matter.regular_customer_company.name",
					width: "200px",
				},
				{
					text: "得意先TEL",
					value: "ordered_product.matter.regular_customer_company.phone",
					width: "200px",
				},
				{
					text: "得意先郵便番号",
					value: "ordered_product.matter.regular_customer_company.zipcode",
					width: "200px",
				},
				{
					text: "得意先住所",
					value: "ordered_product.matter.regular_customer_company.address",
					width: "200px",
				},
				{
					text: "得意先都道府県",
					value: "ordered_product.matter.regular_customer_company.prefecture",
					width: "150px",
				},
				{
					text: "得意先市区町村",
					value: "ordered_product.matter.regular_customer_company.building",
					width: "200px",
				},
				{
					text: "得意先建物番号",
					value: "ordered_product.matter.regular_customer_company.building",
					width: "200px",
				},
				{
					text: "エンドユーザー",
					value: "ordered_product.matter.customer_company.name",
					width: "200px",
				},
				{
					text: "エンドユーザー担当者",
					value: "ordered_product.matter.customer_person.name",
					width: "100px",
				},
				{
					text: "プラントメーカー",
					value: "ordered_product.matter.plant_customer_company.name",
					width: "200px",
				},
				{
					text: "ステータス",
					value: "approval",
					width: "200px",
				}
			],
			order_confirmations: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchOrderConfirmations(1)
	},
	methods: {
		redirectToShowPage(item) {
			this.$router.push({
				name: "order_confirmation_show",
				params: { matter_id: item.matter_id, id: item.id },
			})
		},
		fetchOrderConfirmations(page) {
			const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/order_confirmations`, { params, paramsSerializer, headers })
				.then((res) => {
					this.order_confirmations = res.data.order_confirmations
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchOrderConfirmations(page)
		},
	},
}
</script>
